exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-list .monaco-highlighted-label .highlight{color:#66d9ef!important}.vs-dark .monaco-list-row.focused{background-color:#00305a}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/languages/typescript/autocomplete.css
 ** module id = 196
 ** module chunks = 0
 **/